module.exports = __webpack_public_path__ + "img/3.d6203df4.png";